/* tslint:disable */
/* eslint-disable */
/**
 * Xerjoff.Agenti.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrdineCreateDTO
 */
export interface OrdineCreateDTO {
    /**
     * 
     * @type {string}
     * @memberof OrdineCreateDTO
     */
    idDipendenza?: string | null;
}

/**
 * Check if a given object implements the OrdineCreateDTO interface.
 */
export function instanceOfOrdineCreateDTO(value: object): value is OrdineCreateDTO {
    return true;
}

export function OrdineCreateDTOFromJSON(json: any): OrdineCreateDTO {
    return OrdineCreateDTOFromJSONTyped(json, false);
}

export function OrdineCreateDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrdineCreateDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'idDipendenza': json['idDipendenza'] == null ? undefined : json['idDipendenza'],
    };
}

  export function OrdineCreateDTOToJSON(json: any): OrdineCreateDTO {
      return OrdineCreateDTOToJSONTyped(json, false);
  }

  export function OrdineCreateDTOToJSONTyped(value?: OrdineCreateDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'idDipendenza': value['idDipendenza'],
    };
}

